import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCloudArrowUp, faXmark} from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';

export function Case3({onNext, onPrevious, data, onFilesSelected, formData}) {
    const [devis, setDevis] = useState(formData.devis ? formData.devis : data);

    const MAX_FILES = 5;
    const MAX_TOTAL_SIZE = 15 * 1024 * 1024; // 15 Mo en octets

    const calculateTotalSize = (files) => {
        return files.reduce((total, file) => total + file.size, 0);
    };

    const validateDevis = (devisTemp) => {
        let totalSize = calculateTotalSize(devisTemp);
        for (const element of devisTemp) {
            const file = element;
            const fileType = file.type;

            if (fileType !== 'image/jpeg' && fileType !== 'image/png' && fileType !== 'application/pdf') {
                toast.error('Le type de document est invalide. Sélectionnez une photo ou un pdf.');
                return false;
            }
        }

        const maxSize = 15 * 1024 * 1024;
        if (totalSize > maxSize) {
            toast.error('La taille totale dépasse 15MB');
            return false;
        }
        return true;
    };

    const fileExist = (file) => {
        for (const element of file) {
            if (devis.find((elementDevis) => elementDevis.name === element.name)) {
                toast.error(`Le document ${element.name} existe déjà.`);
                return true;
            }
        }
    };

    const handleFileChange = (e) => {
        e.preventDefault();
        const selectedFiles = Array.from(e.target.files);
        let updatedFiles = devis.concat(selectedFiles);
        const totalSize = calculateTotalSize(updatedFiles);

        if (updatedFiles.length > 5) {
            toast.error(`Vous ne pouvez sélectionner que ${MAX_FILES} fichiers au maximum.`);
            return;
        } else if (totalSize > MAX_TOTAL_SIZE) {
            toast.error(`La taille totale des fichiers sélectionnés ne doit pas dépasser 15 Mo.`);
            return;
        } else if (fileExist(selectedFiles) || !validateDevis(updatedFiles)) {
            return;
        }

        updatedFiles = updatedFiles.map((file, index) => {
            if (file.name === 'image.jpg' || file.name === 'image.jpeg') {
                const fileExtension = file.name.split('.').pop();
                const newName = `image${index}.${fileExtension}`;
                return new File([file], newName, {type: file.type});
            }
            return file;
        });

        setDevis(updatedFiles);
        onFilesSelected(updatedFiles);
        e.target.value = null; // réinitialisation du composant pour que le onChange fonctionne
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateDevis(devis)) {
            return;
        }
        if (devis.length === 0) {
            toast.error('Au moins une pièce jointe est obligatoire.');
            return;
        }
        onFilesSelected(devis);
        onNext({devis});
    };

    const handleDeleteFile = (e, index) => {
        e.preventDefault();
        setDevis((current) =>
            current.filter((file => file.name !== index))
        );
        onFilesSelected((current) =>
            current.filter((file => file.name !== index))
        );
    };

    const createFileList = () => {
        return (
            <div>
                {devis.map((file) => {
                    // Définir la longueur maximale du nom du fichier
                    const MAX_FILENAME_LENGTH = 15;

                    // Extraire le nom du fichier et l'extension
                    const fileName = file.name;
                    const fileExtension = fileName.substr(fileName.lastIndexOf('.'));

                    // Couper le nom du fichier s'il est trop long
                    let displayName = fileName;
                    if (displayName.length > MAX_FILENAME_LENGTH) {
                        displayName = displayName.substring(0, MAX_FILENAME_LENGTH) + '...';
                    }
                    return (
                        <div className="liste-devis" key={file.name}>
                            <div className="file-name">
                                {displayName.length > 15 ? `${displayName}${fileExtension}` : displayName}</div>
                            <div className="croix">
                                <button onClick={(e) => handleDeleteFile(e, file.name)}>
                                    <FontAwesomeIcon icon={faXmark} color="red"/>
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };
    return (
        <div className="texte">
            <h5 className="centered"><b>Etape 2/3</b></h5>
            <hr/>
            <div className="centered">
                <h5><b>Le devis de votre garagiste</b></h5>
            </div>
            <span>
                Pour joindre le devis, cliquez sur l'icône ci-dessous et sélectionnez le fichier
                souhaité.
            </span>
            <p>
                Formats acceptés: pdf, jpg ou png. 15 Mo, 5 fichiers maximum.
            </p>
            <p><i>* champs obligatoire</i></p>
            <div className="rectangle">
                <div className="centered-content">
                    <label htmlFor="file-input">
                        <span><FontAwesomeIcon icon={faCloudArrowUp} size="2xl"/></span>
                    </label>
                    <input
                        type="file"
                        id="file-input"
                        onChange={handleFileChange}
                        accept=".pdf,.jpg,.png, application/pdf"
                        multiple
                    />
                </div>
            </div>
            {createFileList()}
            <div className="app-buttons">
                <button className="buttons-secondaire" onClick={onPrevious}>Retour</button>
                <button className="buttons-primaire" onClick={handleSubmit}>Suivant</button>
            </div>
        </div>
    );
}
